<form [formGroup]="form" (ngSubmit)="saveChanges()">
  <div
    *ngFor="let item of itemsToRename; let i = index"
    class="tenant-feature mb-3"
  >
    <div class="col-12">
      <h2>{{ item.name }}</h2>
      <div class="inpt-title">Custom Title</div>
      <div class="form-group form-floating mb-3">
        <input formControlName="customTitle-{{ i }}" type="text" class="inpt" />
      </div>
    </div>
    <div class="col-12">
      <div class="form-group form-floating mb-3">
        <div class="inpt-title">{{ "Custom Description" }}</div>
        <div class="form-floating mt-3">
          <p-editor
            class="editor"
            placeholder="{{ item.customDescription }}"
            [style]="{ minHeight: '80px' }"
            formControlName="customDescription-{{ i }}"
          >
            <ng-template pTemplate="header">
              <app-editor
                [allowSprintInsert]="true"
                [allowOnboardingInsert]="true"
                [allowToolboxInsert]="true"
              ></app-editor
            ></ng-template>
          </p-editor>
        </div>
      </div>
    </div>
  </div>
  <p-button type="submit" label="{{ 'save' | transloco }}" class="mb-3">
  </p-button>
</form>

<ng-template #editorToolbar>
  <span class="ql-formats">
    <select class="ql-header" aria-label="Header">
      <option selected></option>
      <option value="1">Heading 1</option>
      <option value="2">Heading 2</option>
    </select>

    <button type="button" class="ql-bold" aria-label="Bold"></button>
    <button type="button" class="ql-italic" aria-label="Italic"></button>

    <button
      type="button"
      class="ql-list"
      value="ordered"
      aria-label="Numbered List"
    ></button>
    <button
      type="button"
      class="ql-list"
      value="bullet"
      aria-label="Bullet List"
    ></button>
  </span>
</ng-template>
